import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * SectionHeader — consistent overline + heading + optional description
 * for page and section titles.
 */
const SectionHeader = React.forwardRef(({ overline, title, description, className, size = "section", as = "h2", center = false, rule = false, ...props }, ref) => {
  const Heading = as;
  return (
    <div ref={ref} className={cn("mb-8", center && "text-center", className)} {...props}>
      {overline && (
        rule ? (
          <span className={cn("mb-3 inline-flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.35em] text-amber-400/90", center && "mx-auto")}>
            <span className="h-px w-10 bg-amber-400/70" />
            {overline}
            {center && <span className="h-px w-10 bg-amber-400/70" />}
          </span>
        ) : (
          <span className={cn("overline text-amber-400 mb-3 inline-block", center && "mx-auto")}>{overline}</span>
        )
      )}
      {title && (
        <Heading className={size === "page"
          ? "text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-white break-words"
          : "text-display-sm md:text-display-md font-bold tracking-tighter text-white"}>
          {title}
        </Heading>
      )}
      {description && (
        <p className={cn("text-slate-400 mt-3 max-w-2xl leading-relaxed", center && "mx-auto text-center")}>{description}</p>
      )}
    </div>
  );
})
SectionHeader.displayName = "SectionHeader"

export { SectionHeader }
